export default __webpack_public_path__ + "static/media/SurveyorText-Black.169e9549.woff";